export default function getLinkText(anchorElement: HTMLAnchorElement): string {
    for (let i = 0; i < anchorElement.childNodes.length; i++) {
        const element = anchorElement.childNodes[i];
        if (element.nodeName === '#text') {
            return element.textContent;
        }
    }
    return null;
}
